import { CalendarEvent } from './types';

export interface TournamentInfo {
    key: string;
    name: string;
    dates: string;
    startDate: string; // YYYY-MM-DD
    endDate: string;   // YYYY-MM-DD
    location: string;
    logo?: string;
    url?: string;
    path?: string;
    scheduleUrl?: string;
    standingsUrl?: string;
}

export const TOURNAMENTS_BY_SEASON: Record<string, TournamentInfo[]> = {
    'pw_26_27': [
        { 
            key: 'howies-hometown-cup-2026', 
            name: "CCM Howies Hometown Cup", 
            dates: 'Sep 11-13, 2026',
            startDate: '2026-09-11',
            endDate: '2026-09-13',
            location: 'Grand Rapids, MI',
            logo: '/tournament-logos/200x85-Howies-Howies-Hometown-Cup_300.png',
            url: 'https://200x85.com/event/howies-hometown-cup/',
            path: '/tournaments/howies-hometown-cup-2026',
            scheduleUrl: 'https://my.200x85.com/tournaments/b242def3-6e03-4dba-8a7f-6b5960f35df0/teams/94e4431b-9173-4d1a-a686-7a4fb8ee13cb',
            standingsUrl: 'https://my.200x85.com/tournaments/b242def3-6e03-4dba-8a7f-6b5960f35df0/standings?division=895'
        },
        { 
            key: 'ccm-world-invite-2026', 
            name: 'CCM World Invite', 
            dates: 'Nov 6-8, 2026',
            startDate: '2026-11-06',
            endDate: '2026-11-08',
            location: 'Chicago, IL',
            logo: '/tournament-logos/200x85-CCM-World-Invite-City-Chicago_300.png',
            url: 'https://200x85.com/event/ccm-world-invite/',
            path: '/tournaments/ccm-world-invite-2026',
            scheduleUrl: 'https://my.200x85.com/tournaments/1a0a158e-5bf4-4e1e-93a9-01bb7e7963ba/teams/94e4431b-9173-4d1a-a686-7a4fb8ee13cb',
            standingsUrl: 'https://my.200x85.com/tournaments/1a0a158e-5bf4-4e1e-93a9-01bb7e7963ba/standings?division=994'
        },
        { 
            key: 'silver-sticks-2026', 
            name: 'Silver Sticks', 
            dates: 'Nov 27-29, 2026',
            startDate: '2026-11-27',
            endDate: '2026-11-29',
            location: 'Chicago, IL',
            logo: '/tournament-logos/silver-sticks-logo.png',
            url: 'https://silverstick.org/Tournaments/33085/',
            path: '/tournaments/silver-sticks-2026'
        },
        { 
            key: 'super-series-2027', 
            name: 'Super Series', 
            dates: 'Jan 8-10, 2027',
            startDate: '2027-01-08',
            endDate: '2027-01-10',
            location: 'Pittsburgh, PA',
            logo: '/tournament-logos/pittsburgh-showcase-2025-logo.webp',
            url: 'https://superserieshockey.com/events/pittsburgh-showcase/',
            path: '/tournaments/super-series-2027'
        },
        { 
            key: 'ccm-mlk-mayhem-2027', 
            name: 'CCM MLK Mayhem', 
            dates: 'Jan 16-18, 2027',
            startDate: '2027-01-16',
            endDate: '2027-01-18',
            location: 'Chicago, IL',
            logo: '/tournament-logos/200X85-MLK-Midwest-Mayhem_300.png',
            url: 'https://200x85.com/event/mlk-midwest-mayhem/',
            path: '/tournaments/ccm-mlk-mayhem-2027'
        },
        {
            key: 'csdhl-playoffs-2027',
            name: 'CSDHL Playoffs',
            dates: 'Feb 4-7, 2027',
            startDate: '2027-02-04',
            endDate: '2027-02-07',
            location: 'Chicago, IL',
            logo: '/tournament-logos/csdhl-logo.png',
            path: '/tournaments/csdhl-playoffs-2027'
        },
        {
            key: 'ahai-state-tournament-2027',
            name: 'AHAI State Tournament',
            dates: 'Feb 1-Mar 8, 2027',
            startDate: '2027-02-01',
            endDate: '2027-03-08',
            location: 'Chicago, IL',
            logo: '/tournament-logos/ahai-logo.png',
            path: '/tournaments/ahai-state-tournament-2027'
        },
    ],
    'pw_25_26': [
        { 
            key: 'howies-hometown-cup-2025', 
            name: "Howie's Hometown Cup", 
            dates: 'Sept 5-7, 2025',
            startDate: '2025-09-05',
            endDate: '2025-09-07',
            location: 'Grand Rapids, MI',
            logo: '/tournament-logos/200x85-Howies-Howies-Hometown-Cup_300.png',
            url: 'https://200x85.com/event/howies-hometown-cup/',
            path: '/tournaments/howies-hometown-cup-2025',
            scheduleUrl: 'https://my.200x85.com/tournaments/44eaf589-fcfb-4a79-8654-54d45459c333/teams/94e4431b-9173-4d1a-a686-7a4fb8ee13cb',
            standingsUrl: 'https://my.200x85.com/tournaments/44eaf589-fcfb-4a79-8654-54d45459c333/standings?division=578'
        },
        { 
            key: 'ccm-motown-2025', 
            name: 'CCM Motown', 
            dates: 'Oct 17-19, 2025',
            startDate: '2025-10-17',
            endDate: '2025-10-19',
            location: 'Detroit, MI',
            logo: '/tournament-logos/200x85-CCM-Motown_City-Detroit_300-1.png',
            url: 'https://200x85.com/event/ccm-motown/',
            path: '/tournaments/ccm-motown-2025',
            scheduleUrl: 'https://my.200x85.com/tournaments/4a17c3fc-c6af-4605-9fd6-7d35d1f48193/teams/94e4431b-9173-4d1a-a686-7a4fb8ee13cb',
            standingsUrl: 'https://my.200x85.com/tournaments/4a17c3fc-c6af-4605-9fd6-7d35d1f48193/standings?division=641'
        },
        { 
            key: 'ccm-world-invite-2025', 
            name: 'CCM World Invite', 
            dates: 'Nov 7-9, 2025',
            startDate: '2025-11-07',
            endDate: '2025-11-09',
            location: 'Chicago, IL',
            logo: '/tournament-logos/200x85-CCM-World-Invite-City-Chicago_300.png',
            url: 'https://200x85.com/event/ccm-world-invite/',
            path: '/tournaments/ccm-world-invite-2025'
        },
        { 
            key: 'ccm-mlk-mayhem-2026', 
            name: 'CCM MLK Mayhem', 
            dates: 'Jan 17-19, 2026',
            startDate: '2026-01-17',
            endDate: '2026-01-19',
            location: 'Chicago, IL',
            logo: '/tournament-logos/200X85-MLK-Midwest-Mayhem_300.png',
            url: 'https://200x85.com/event/mlk-midwest-mayhem/',
            path: '/tournaments/ccm-mlk-mayhem-2026'
        },
        {
            key: 'csdhl-playoffs-2026',
            name: 'CSDHL Playoffs',
            dates: 'Feb 5-8, 2026',
            startDate: '2026-02-05',
            endDate: '2026-02-08',
            location: 'Chicago, IL',
            logo: '/tournament-logos/csdhl-logo.png',
            path: '/tournaments/csdhl-playoffs-2026'
        },
        {
            key: 'ahai-state-tournament-2026',
            name: 'AHAI State Tournament',
            dates: 'Feb 2-Mar 9, 2026',
            startDate: '2026-02-02',
            endDate: '2026-03-09',
            location: 'Chicago, IL',
            logo: '/tournament-logos/ahai-logo.png',
            path: '/tournaments/ahai-state-tournament-2026'
        },
    ]
};

export const TOURNAMENTS: TournamentInfo[] = [
    ...TOURNAMENTS_BY_SEASON['pw_26_27'],
    ...TOURNAMENTS_BY_SEASON['pw_25_26']
];

export function getTournamentsForSeason(seasonKey: string): TournamentInfo[] {
    return TOURNAMENTS_BY_SEASON[seasonKey] || [];
}

export function getTournamentCalendarEvents(): CalendarEvent[] {
    return TOURNAMENTS.map(t => ({
        summary: t.name,
        start: `${t.startDate}T00:00:00`,
        end: `${t.endDate}T23:59:59`,
        location: t.location,
        url: getTournamentLink(t),
        isTournament: true,
        isMultiDay: true,
    }));
}

/**
 * Safely parses YYYY-MM-DD string into a local Date instance avoiding timezone offsets.
 */
export function parseLocalDate(dateStr: string): Date {
    const parts = dateStr.split('-');
    if (parts.length === 3) {
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const day = parseInt(parts[2], 10);
        return new Date(year, month, day);
    }
    return new Date(dateStr);
}

/**
 * Calculates day difference between date1 and date2.
 */
export function getDayDiff(date1: Date, date2: Date): number {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

/**
 * Resolves the primary internal or external link for a tournament.
 */
export function getTournamentLink(tournament: TournamentInfo): string {
    return tournament.path || (tournament.key ? `/tournaments/${tournament.key}` : tournament.url || '/');
}

/**
 * Determines whether a tournament is currently active/ongoing on the given date.
 */
export function isTournamentOngoing(tournament: TournamentInfo, currentDate: Date = new Date()): boolean {
    const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const start = parseLocalDate(tournament.startDate);
    const end = parseLocalDate(tournament.endDate);
    return today >= start && today <= end;
}

/**
 * Returns number of days until the tournament begins (0 if today or in past).
 */
export function getDaysUntilTournament(tournament: TournamentInfo, currentDate: Date = new Date()): number {
    const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const start = parseLocalDate(tournament.startDate);
    return getDayDiff(today, start);
}

/**
 * Determines whether a tournament is upcoming within maxDaysAhead days (default: 14 days).
 */
export function isTournamentUpcoming(tournament: TournamentInfo, currentDate: Date = new Date(), maxDaysAhead: number = 14): boolean {
    const daysUntil = getDaysUntilTournament(tournament, currentDate);
    return daysUntil > 0 && daysUntil <= maxDaysAhead;
}

/**
 * Finds the currently active tournament, or the closest upcoming tournament within 14 days for a season.
 */
export function getActiveOrUpcomingTournament(seasonKey: string, currentDate: Date = new Date()): {
    tournament: TournamentInfo;
    isOngoing: boolean;
    daysUntil: number;
} | null {
    const tournaments = getTournamentsForSeason(seasonKey);
    if (!tournaments || tournaments.length === 0) return null;

    // 1. Check for ongoing tournament first
    for (const t of tournaments) {
        if (isTournamentOngoing(t, currentDate)) {
            return {
                tournament: t,
                isOngoing: true,
                daysUntil: 0
            };
        }
    }

    // 2. Check for upcoming tournaments within 14 days
    const upcoming = tournaments
        .map(t => ({
            tournament: t,
            isOngoing: false,
            daysUntil: getDaysUntilTournament(t, currentDate)
        }))
        .filter(item => item.daysUntil > 0 && item.daysUntil <= 14)
        .sort((a, b) => a.daysUntil - b.daysUntil);

    if (upcoming.length > 0) {
        return upcoming[0];
    }

    return null;
}